import { useMemo } from "react";
import { useAuth } from "@src/common/hooks/useAuth";
import type { Shipment, Stop } from "@api/graphql/generated/generated-types";
import { sortShipmentStopsByRouteOrder } from "@src/shipments/utils/sortShipmentStopsByRouteOrder";
import { useShipmentManualArrivalOverrideQuery } from "./useShipmentManualArrivalOverrideQuery";

export function useManualArrivalData(
  shipment: Shipment | undefined,
  isShipmentAssigned: boolean,
) {
  const { courierId } = useAuth();

  const { data: manualArrivalData, loading } =
    useShipmentManualArrivalOverrideQuery({
      variables: {
        courierId: courierId!,
        shipmentId: shipment?.id!,
      },
      skip: !courierId || !shipment?.id || !isShipmentAssigned,
      fetchPolicy: "no-cache",
    });

  const arrivalShipment = manualArrivalData?.shipmentById;

  const sortedStops = useMemo(
    () =>
      sortShipmentStopsByRouteOrder<Stop>(
        (arrivalShipment?.stops as Stop[] | null | undefined) ??
          (shipment?.stops as Stop[] | null | undefined),
      ),
    [arrivalShipment, shipment],
  );

  return { sortedStops, loading, arrivalShipment };
}
